import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function ProfileShareRedirect() {
  const { username } = useParams();
  const safeUsername = username || 'aphel';
  const appUrl = `aphel://u/${encodeURIComponent(safeUsername)}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = appUrl;
    }, 100);
    return () => clearTimeout(timer);
  }, [appUrl]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>APHEL</div>
        <h1 style={styles.title}>Open in Aphel</h1>
        <p style={styles.subtitle}>
          @{safeUsername} profilini uygulamada goruntule.
        </p>
        <a style={styles.primaryButton} href={appUrl}>
          Aphel uygulamasini ac
        </a>
        <p style={styles.note}>
          Uygulama acilmazsa, Aphel uygulamasini yukleyip tekrar deneyin.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'radial-gradient(circle at top, #1f2937 0%, #0b1020 60%, #07080f 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    color: '#fff',
    fontFamily: 'Helvetica, Arial, sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: 'rgba(17,24,39,0.92)',
    borderRadius: '24px',
    padding: '32px',
    boxShadow: '0 30px 60px rgba(0,0,0,0.35)',
    border: '1px solid rgba(255,255,255,0.08)',
    textAlign: 'center',
  },
  logo: {
    letterSpacing: '6px',
    fontWeight: 700,
    fontSize: '12px',
    marginBottom: '16px',
  },
  title: {
    fontSize: '28px',
    margin: '0 0 10px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#cbd5f5',
    marginBottom: '24px',
  },
  primaryButton: {
    display: 'inline-block',
    background: '#1d4ed8',
    color: '#fff',
    padding: '12px 20px',
    borderRadius: '14px',
    textDecoration: 'none',
    fontWeight: 600,
    marginBottom: '16px',
  },
  note: {
    fontSize: '12px',
    color: '#94a3b8',
  },
};
